if (!customElements.get('ap-promo-strip')) {
  customElements.define('ap-promo-strip', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.expiresAt = Number(this.dataset.expires) * 1000;
      this.dismissKey = this.dataset.dismissKey;
      this.designMode = this.dataset.designMode === 'true';
      this.controller = new AbortController();
      const closeButton = this.querySelector('.ap-promo-strip__close');
      if (closeButton) {
        closeButton.hidden = false;
        closeButton.addEventListener('click', () => {
          this.dismissed = true;
          this.hidden = true;
          clearTimeout(this.expiryTimer);
          try {
            if (!this.designMode && this.dismissKey) sessionStorage.setItem(this.dismissKey, '1');
          } catch {}
        }, { signal: this.controller.signal });
      }
      this.checkExpiry = () => {
        clearTimeout(this.expiryTimer);
        try {
          if (!this.designMode && this.dismissKey && sessionStorage.getItem(this.dismissKey) === '1') this.dismissed = true;
        } catch {}
        if (this.dismissed) {
          this.hidden = true;
          return;
        }
        if (!this.expiresAt || !Number.isFinite(this.expiresAt)) return;
        const remaining = this.expiresAt - Date.now();
        if (remaining <= 0) {
          this.hidden = true;
          return;
        }
        this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
      };
      window.addEventListener('pageshow', this.checkExpiry, { signal: this.controller.signal });
      document.addEventListener('visibilitychange', this.checkExpiry, { signal: this.controller.signal });
      this.checkExpiry();
    }

    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      this.controller?.abort();
    }
  });
}
